import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { PlusCircle } from "lucide-react";

import { useMyCompanyQuery } from "@/queries/company/my-company";
import { AdminJobDetails } from "@/queries/admin/job-details";

import { CompanyJobOpening } from "@/types";
import AddOpportunityForm from "@/components/forms/company/opportunity";

export const AddOpportunityDialog = ({
  open,
  setOpen,
  opening,
  trigger,
  includeMaskedJobDescription,
  companyId,
}: {
  open: boolean;
  setOpen: (v: boolean) => void;
  opening?: CompanyJobOpening | AdminJobDetails;
  trigger?: React.ReactNode;
  includeMaskedJobDescription?: boolean;
  companyId?: string;
}) => {
  const { companyLoading } = useMyCompanyQuery(companyId);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger ? (
          trigger
        ) : (
          <Button disabled={companyLoading}>
            <PlusCircle />
            Add An Opportunity
          </Button>
        )}
      </DialogTrigger>
      <DialogContent
        className="w-full p-0 sm:max-w-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <DialogHeader className="p-6">
          <div className="flex items-center gap-2">
            <DialogTitle>{opening ? "Edit" : "Add"} an Opportunity</DialogTitle>
          </div>
          <DialogDescription className="sr-only">
            Enter the details of the opportunity here and click &quot;Save&quot;
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="sm:max-h-[calc(100vh-10rem)] md:max-h-[70vh] px-6 pb-6">
          <AddOpportunityForm
            opening={opening}
            includeMaskedJobDescription={includeMaskedJobDescription}
            companyId={companyId}
            onSuccess={() => setOpen(false)}
            includeSteps
          />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
